/**
 * The per-participant outcome a therapist records after an appointment.
 *
 * Orthogonal to `CallPatientStatus` (which is the patient's *pre-meeting*
 * invite acknowledgement: ACCEPTED / DECLINED / PENDING). `AttendanceOutcome`
 * is set by the therapist via `ConfirmAppointmentCommand` (TM-9071) and
 * answers a different question: *what actually happened*.
 *
 * The appointment-level `AppointmentStatus` is a roll-up over the
 * participants' attendance outcomes — see `rollUpAppointmentStatus`.
 */
export var AttendanceOutcome;
(function (AttendanceOutcome) {
    AttendanceOutcome["ATTENDED"] = "ATTENDED";
    AttendanceOutcome["NO_SHOW"] = "NO_SHOW";
    AttendanceOutcome["CANCELLED"] = "CANCELLED";
})(AttendanceOutcome || (AttendanceOutcome = {}));
//# sourceMappingURL=attendance-outcome.enum.js.map